<template>
  <div>
    <div class="vx-row mb-4">
      <div class="vx-col md:w-1/2 w-full">
        <h2>{{ $t('Ofertas') }}</h2>
      </div>
      <div class="vx-col md:w-1/2 w-full">
        <div class="text-right" >
          <router-link
            :to="{ name: 'new-sale'}"
          >
            <vs-button color="primary" type="border">{{ $t('sale.CreateSale') }}</vs-button>
          </router-link>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
          <table-data-grid :data="itemsDataGrid" :dataColumns="dataColumns" >
            <template v-slot:actions="slotProps" >
              <div class="dropdown-button-container">

                  <vs-button class="btnx" type="filled" color="primary" @click="seeSale(slotProps.item.id)" >
                    {{ $t('Ver') }}
                  </vs-button>

              <vs-dropdown vs-trigger-click>
               <vs-button class="btn-drop" type="filled" icon="expand_more"></vs-button>
              <vs-dropdown-menu>
                    <ul style="min-width: 12rem">
                       <li>
                        <router-link :to="slotProps.item.linkEdit" class="cursor-pointer py-3 px-4 block hover:bg-primary hover:text-white w-full" >
                          <feather-icon icon="EditIcon" svgClasses="w-4 h-4" />
                          <span class="ml-2">{{ $t('Editar') }}</span>
                        </router-link>
                        <vs-divider class="m-1" />
                      </li>
                      <li>
                        <span @click="assignToUser(slotProps.item)" class="cursor-pointer py-3 px-4 block hover:bg-primary hover:text-white w-full text-primary" >
                         <feather-icon icon="EditIcon" svgClasses="w-4 h-4" />
                          <span class="ml-2">{{ $t('Assign') }}</span>
                          </span>
                      </li>

                       <vs-divider class="m-1" />
                        <li>
                         <span @click="deleteModalSale(slotProps.item.id, slotProps.item.name)" class="cursor-pointer py-3 px-4 block text-danger hover:text-black w-full" >
                         <feather-icon icon="TrashIcon" svgClasses="w-4 h-4" />
                          <span class="ml-2">{{ $t('Eliminar') }}</span>
                          </span>
                      </li>
                    </ul>
              </vs-dropdown-menu>
              </vs-dropdown>
              </div>
            </template>
          </table-data-grid>
          <vs-popup :title="$t('sale.SeeSale')" class="popup-w-900" :active.sync="popupSeeSale">
            <see-sale
            :sale="sale"/>

          </vs-popup>
          <vs-popup :title="$t('sale.UserEmail')" class="popup-w-900" :active.sync="popupAssignSale">
            <assign-sale
             :sale="sale_to_assign"/>
          </vs-popup>
      </div>
    </div>
  </div>
</template>

<script>
    import TableDataGrid from '../components/TableDataGrid';
    import GenerateQr from '../components/GenerateQr';
    import AssignSale from '@/components/Sale/AssignSale';
    import SaleEdit from '@/views/SaleEdit'
    import SeeSale from '@/components/Sale/SeeSale'
    import {mapActions, mapGetters} from 'vuex';

    export default {
        components: {
            TableDataGrid,
            GenerateQr,
            AssignSale,
            SaleEdit,
            SeeSale
        },
        data () {
            return {
                dialog: false,
                sale_to_assign:0,
                dataColumns: [
                    {caption: 'ID', visible: false},
                    {caption: 'linkEdit', visible: false},
                    {dataField: 'name', caption: this.$t('Nombre'), visible: true, width: 250},
                    {dataField: 'spec', caption: this.$t('Tipo_de_oferta'), visible: true, width: 100},
                    {dataField: 'sale_code', caption: this.$t('sale.SaleCode'), visible: true, width: 100},
                    {dataField: 'description',caption: this.$t('Descripcion'), visible: true, width: 600},
                    {dataField: 'finished_at',caption: this.$t('Hasta'), visible: true, width: 600},
                    {dataField: 'global', visible: false},
                    {caption: 'Slug', dataType: 'text', visible: false}
                ]
            }
        },
        created () {
            this.refreshSales({language: this.language});
        },
        computed: {
            ...mapGetters({
                languages: 'getLanguages',
                itemsSales: 'getSales',
                language: 'getCurrentLanguage',
                sale:'getSale'
            }),
            popupAssignSale: {
                get ()    { return this.$store.getters.getpopupAssignSale },
                set (val) { this.$store.commit('setpopupAssignSale', val) }
            },
             popupSeeSale: {
                get ()    { return this.$store.getters.getpopupSeeSale },
                set (val) { this.$store.commit('setpopupSeeSale', val) }
            },
            openModal () {
                if (this.popupSeeSale === true) {
                    return true;
                }
                return false;
            },

            itemsDataGrid () {
                const items = this.itemsSales;
                const results = [];
                let auxSpec = []
                items.forEach((item, index) => {
                let auxSpecString = ''
                let auxString = ''
                let dateString = ''
                  if (items[index].details) {
                    auxString = items[index].details
                  } else {
                    auxString = 'No tiene descripcion'
                  }

                  if (!items[index].finished_at) {
                    dateString = 'No tiene fecha de caducidad'
                  } else {
                       dateString = items[index].finished_at.replace('/t','/t/t')
                  }

                  if (items[index].type_sale === 1 && items[index].type_sale_specification !== null) {
                    auxSpec = items[index].type_sale_specification.split(':')
                    auxSpecString = `${auxSpec[1].replace('}','').replaceAll('"','').replaceAll('\\','')  }%`
                  } else if (items[index].type_sale_specification !== null) {
                    const auxSpecArray = items[index].type_sale_specification.split(',')
                    const auxTypeSale = auxSpecArray[0].split(':')
                    auxSpecString = auxTypeSale[1].replace('"','').replace('"','')
                    auxSpecString = auxSpecString.replace('}','€')
                  }

                  results[index] = {
                      id: items[index].id,
                      linkEdit: `edit-sale/${items[index].id}`,
                      name: items[index].name,
                      spec: auxSpecString,
                      sale_code: items[index].sale_code,
                      details: auxString,
                      finished_at: dateString.replace(' ',' a las '),
                      type_sale: items[index].type_sale,
                      global: items[index].global
                  };

                }, items)

                return results
            }
        },
        methods: {
            ...mapActions({
                refreshSales: 'refreshSales',
                deleteSale: 'deleteSale',
                getSale:'getSale',
            }),

            deleteModalSale (id, name) {
                const aux = this;
                this.$vs.dialog({
                    type:'confirm',
                    color: 'danger',
                    title: this.$t('sale.EliminarOferta'),
                    text: this.$t('sale.EliminarConfirm', {nombre: name}),
                    acceptText: this.$t('Aceptar'),
                    cancelText: this.$t('Cancelar'),
                    accept () {
                        aux.deleteSale(id)
                    }
                })
            },
             assignToUser(item) {
              if (item.global) {
                this.$store.commit('notifications', {
                  title: 'No se pueden asignar ofertas globales',
                  color: 'warning'
                });
                this.$store.commit('showNotifications', true);
              } else {
                this.popupAssignSale = true
                this.sale_to_assign = item.id
              }
            },
              seeSale(id) {
                this.getSale({id, language: this.language});
                this.popupSeeSale = true
            }
        }
    }
</script>

<style></style>
